import React from 'react';

import cn from 'clsx';
import { Icon } from '@components-clean/core/icons/icon';
import styles from '@components-clean/core/icons/styles.module.scss';

type Props = {
    dataTestId: string;
    className?: string;
    tooltip: string;
    defaultOpacity?: 75 | 100;
};

export const SimplifiedPanelIcon = ({ dataTestId, className, defaultOpacity, tooltip, ...rest }: Props) => {
    return (
        <Icon
            className={cn(className, styles.secondary, {
                [styles.opacity100]: defaultOpacity === 100,
                [styles.opacity75]: defaultOpacity === 75,
            })}
            title={tooltip}
            dataTestId={dataTestId}
            icon={['fal', 'file-half-dashed']}
            tooltipPosition="top"
            {...rest}
        />
    );
};
